import React, { Fragment, useEffect, useState } from 'react';
import { Box, Checkbox, Divider, FormControlLabel, TextField, Dialog, Button, Typography, Snackbar} from '@mui/material';
import './secret.css';
import RegisterAPI from '../../api/register/register_api'
import Loader from '../../components/loader/loader';
import { AddCompanyAPI } from '../../api/company/addCompany';
import GetAllUser from '../../api/user/get_all_user';

const Secret = ()=>{

    const [redirect, setRedirect] = useState(false);
    const [success, setSuccess] = useState(false);
    const [seeCompanyDetail, setSeeCompanyDetail] = useState(false);
    const [addCompany, setAddCompany] = useState(false);
    const [employeeDetail, setEmployeeDetail] = useState(false);
    const [companyId, setCompanyId] = useState(null);
    const [addEmployee, setAddEmployee] = useState(false);
    const [addEmployeeDetail, setAddEmployeeDetail] = useState({
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        password: null,
        confirm_password: null,
        admin: false,
        companyId: companyId
    });
    const [addCompanyDetail, setAddCompanyDetail] = useState({
        companyName: null,
        companyAddress: null,
        companyWebsite: null,
        companyContactNumber: null,
        companyEmailAddress: null
    })
    const [flagLoader, setFlagLoader] = useState(false);
    const [dataAddedSnackbar, setDataAddedSnackbar] = useState(false);
    const [flagCompanySaved, setFlagCompanySaved] = useState(false);

    useEffect(()=>{
        let password = prompt("Please Enter Secret Password.", "");
        if(Number(password) === NaN){
            setRedirect(true);
        }
        else if(Number(password) === 9723032911){
            setSuccess(true);
        }
        else{
            setRedirect(true);
        }
    }, []);

    const GetAllUserInCompany = ()=>{
        setFlagLoader(true);
            GetAllUser({ companyId: companyId }, (res)=>{
                setFlagLoader(false)
                console.log("Printing res", res);

                if(res.data.status === true){
                    setEmployeeDetail(res.data.data);
                }
                else{
                    alert("Something went wrong, Please try again later.!");
                }
            }, (err)=>{
                setFlagLoader(false)
                console.log("Printing err", err);
                alert("Something went wrong, Please try again later.!");
            })
    }

    useEffect(()=>{
        if(companyId !== null){
            setAddEmployeeDetail({
                ...addEmployeeDetail,
                companyId: companyId
            })
            GetAllUserInCompany();
        }
    }, [companyId])

    const ChangeAddEmployeeDetail = (value, field)=>{
        setAddEmployeeDetail({
            ...addEmployeeDetail,
            [field]: value
        })
    }

    return (
        <Fragment>
            <Box className="main_secret_page">
            {flagLoader === true && <Loader  />}
            {dataAddedSnackbar == true && <Snackbar open={true} onClose={()=>{setDataAddedSnackbar(false)}} autoHideDuration={5000} message="Data Added Successfully.!" />}
            {addEmployee === true && <Dialog open={true} onClose={()=>{setAddEmployee(false)}}>
                <Box className="add_employee_dialog_content">
                    <Typography variant="h3">Add Employee</Typography>
                    <Box style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <Box className="first_name add_employee_input">
                        <TextField variant="standard" value={addEmployeeDetail.first_name} onChange={(e)=>{ChangeAddEmployeeDetail(e.target.value, "first_name")}} label="First Name" />
                    </Box>
                    <Box className="last_name add_employee_input">
                        <TextField variant="standard" value={addEmployeeDetail.last_name} onChange={(e)=>{ChangeAddEmployeeDetail(e.target.value, "last_name")}} label="Last Name" />
                    </Box>
                    </Box>
                    <Box style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <Box className="email add_employee_input">
                        <TextField variant="standard" value={addEmployeeDetail.email} onChange={(e)=>{ChangeAddEmployeeDetail(e.target.value, "email")}} label="Email Address" type="email" />
                    </Box>
                    <Box className="phone add_employee_input">
                        <TextField variant="standard" value={addEmployeeDetail.phone} onChange={e=>{ChangeAddEmployeeDetail(e.target.value, "phone")}} label="Phone Number" type="tel" />
                    </Box>
                    </Box>
                    <Box style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <Box className="password add_employee_input">
                        <TextField variant="standard" value={addEmployeeDetail.password} onChange={(e)=>{ChangeAddEmployeeDetail(e.target.value, "password")}} label="Password" type="password" />    
                    </Box>
                    <Box className="confirm_password add_employee_input">
                        <TextField variant="standard" value={addEmployeeDetail.confirm_password} onChange={(e)=>{ChangeAddEmployeeDetail(e.target.value, "confirm_password")}} label="Confirm Password" type="password" />
                    </Box>
                    </Box>
                    <Box className="admin add_employee_input">
                        <FormControlLabel control={<Checkbox checked={addEmployeeDetail.admin} />} label="Admin?" onChange={(e)=>{ChangeAddEmployeeDetail(e.target.checked, "admin")}} />
                    </Box>
                    <Button onClick={()=>{
                        setFlagLoader(true)
                        RegisterAPI(addEmployeeDetail, (res)=>{
                            setFlagLoader(false);
                            console.log("Printing res", res)
                            setAddEmployeeDetail({
                                first_name: null,
                                last_name: null,
                                email: null,
                                password: null,
                                phone: null,
                                confirm_password: null,
                                admin: false,
                                companyId: companyId
                            });
                            GetAllUserInCompany();
                        }, (err)=>{
                            setFlagLoader(false);
                            console.log(err);
                        })
                    }}>Save</Button>
                </Box>
            </Dialog>}
            {redirect === true && window.location.replace("/")}
            {success === true && <Fragment>
                    <Typography variant="h4" style={{color: "#4f62dd", textAlign: "center"}}>Onbord For Developers</Typography>
                    <Box className="secret_page">
                        <Button onClick={()=>{setAddCompany(true)}}>Add New Company</Button>
                    </Box>
                </Fragment>}
            {addCompany === true && <Fragment>
                    <Box className="add_company_page">
                        <Divider />
                        <Typography variant="h5">Add Company Details:-</Typography>
                        <Box style={{display: "flex", alignItems: "center", justifyContent: "space-around", flexWrap: "wrap"}}>
                        <Box className="company_name company_field">
                            <TextField
                                type="text"
                                value={addCompanyDetail?.companyName}
                                onChange={(e)=>{
                                    setAddCompanyDetail({
                                        ...addCompanyDetail,
                                        companyName: e.target.value
                                    })
                                }}
                                variant="standard"
                                label="Company Name"
                            />
                        </Box>
                        <Box className="company_website company_field">
                            <TextField
                                type="url"
                                value={addCompanyDetail?.companyWebsite}
                                onChange={e => {
                                    setAddCompanyDetail({
                                        ...addCompanyDetail,
                                        companyWebsite: e.target.value
                                    })
                                }}
                                variant="standard"
                                label="Company Website"
                            />
                        </Box>
                        <Box className="company_address company_field">
                            <TextField
                                variant="standard"
                                label="Company Address"
                                type="text"
                                value={addCompanyDetail?.companyAddress}
                                onChange={e => {
                                    setAddCompanyDetail({
                                        ...addCompanyDetail,
                                        companyAddress: e.target.value
                                    })
                                }}
                            />
                        </Box>
                        <Box className="company_contact_number company_field">
                            <TextField
                                type="tel"
                                variant="standard"
                                value={addCompanyDetail?.companyContactNumber}
                                label="Company Contact Number"
                                onChange={e => {
                                    setAddCompanyDetail({
                                        ...addCompanyDetail,
                                        companyContactNumber: e.target.value
                                    })
                                }}
                            />
                        </Box>
                        <Box className="company_email_address company_field">
                            <TextField
                                type="email"
                                variant="standard"
                                label="Company Email Address"
                                value={addCompanyDetail?.companyEmailAddress}
                                onChange={e => {
                                    setAddCompanyDetail({
                                        ...addCompanyDetail,
                                        companyEmailAddress: e.target.value
                                    })
                                }}
                            />
                        </Box>
                        </Box>
                        {flagCompanySaved === true && <span style={{color: "lightgreen"}}>Data Added Successfully.!</span>}
                        <br/>
                        <Button onClick={()=>{
                            setFlagLoader(true);
                            AddCompanyAPI(addCompanyDetail, (res)=>{
                                setFlagLoader(false);
                                console.log("Printing response for add company", res);

                                if(res.data.status === true){
                                    setCompanyId(res.data.data);setFlagCompanySaved(true)
                                }
                                else{
                                    console.log("Hello");
                                }
                            }, (err)=>{
                                setFlagLoader(false);
                                console.log("Printing error for add company", err);
                                alert("Something went wrong, Please try again later.!");
                            })
                        }}>Save Company</Button>
                        <Divider />
                        {flagCompanySaved === true && <Button onClick={()=>{setAddEmployee(true)}}>Add Employee</Button>}
                        <Box style={{display: "flex", justifyContent: "space-around", alignItems: "center", flexWrap: "wrap"}}>
                        {
                            employeeDetail?.length > 0 && employeeDetail.map((emp, index)=>{
                                return (
                                    <Box className="employee_detail" key={index}>
                                        <Typography variant="h6">Name: {emp?.first_name} {emp?.last_name}</Typography>
                                        <Typography variant="h6">Email: {emp?.email}</Typography>
                                        <Typography variant="h6">Phone: {emp?.phone}</Typography>
                                        <Typography variant="h6">Admin: {emp?.admin === true ? "Yes" : "No"}</Typography>
                                    </Box>
                                )
                            })
                        }
                        </Box>
                    </Box>
                </Fragment>}
            </Box>
        </Fragment>
    )
};

export default Secret;